<ion-row>
  <ion-col class="ion-no-padding">
    <ion-card class="ion-no-margin airport-hero">
      <div class="img-container">
        <ion-img
          class="hero-banner-img"
          [src]="bannerInfo.image || noHeaderImage"
        >
        </ion-img>
        <div class="item-overlay w100 ion-padding-top ion-margin-top">
          <ion-item lines="none" (click)="openModal()">
            <ion-thumbnail slot="start" class="ion-no-margin marr10">
              <ng-template [ngIf]="bannerInfo?.logo">
                <img [src]="bannerInfo?.logo || placeholder" (error)="handleImageError($event)"/>
              </ng-template>
              <ng-template [ngIf]="!bannerInfo?.logo">
                <h2
                  *ngIf="bannerInfo.code"
                  style="margin: 25% auto"
                  class="font14 ion-text-center desc-text-color"
                >
                  {{ bannerInfo.code }}
                </h2>
                <h2
                  *ngIf="!bannerInfo.code"
                  style="margin: 0px; margin-top: 8px"
                  class="ion-text-center desc-text-color"
                >
                  <ion-icon name="location-sharp"></ion-icon>
                </h2>
              </ng-template>
            </ion-thumbnail>
            <ion-label>
              <div
                class="d-flex ion-justify-content-start ion-align-items-center"
              >
                <div class="ion-no-padding padr5 width300">
                  <h3
                    *ngIf="bannerInfo.city"
                    class="font14 font500 airport-name white-text-color"
                  >
                    {{ bannerInfo.name }}
                  </h3>
                  <span
                    *ngIf="bannerInfo.city && bannerInfo.name"
                    class="line-clamp-2 font12 font400 white-text-color"
                  >
                    {{ bannerInfo.city }}
                  </span>
                  <span
                    *ngIf="!bannerInfo.city"
                    class="fs-3 font12 font500 white-text-color"
                  >
                    Select Airport
                  </span>
                </div>
                <ion-icon
                  class="white-icon-color downArrow"
                  slot="end"
                  name="chevron-down"
                ></ion-icon>
              </div>
            </ion-label>
          </ion-item>

          <div class="ion-no-padding ion-padding-horizontal padt5 mart10">
            <h4 *ngIf="userName" class="fs-5 font600 white-text-color">
              Hey {{ userName }}!
            </h4>
            <h4 *ngIf="!userName" class="fs-5 font600 white-text-color">
              Hey Traveller!
            </h4>
            <p class="fs-3 font500 white-text-color">
              Explore and Claim exclusive membership perks reserved for you!
            </p>
          </div>

          <div class="d-flex ion-justify-content-center">
            <ion-chip
              (click)="navigateTo()"
              class="whiteBorder ion-justify-content-around br-10"
              [ngClass]="
                userInfo?.subscribedTier?.tier === 'LITE'
                  ? 'lite-chip'
                  : 'premium-chip'
              "
            >
              <div
                class="ion-no-padding ion-padding-end padl5 d-flex ion-align-items-center"
              >
                <img [src]="userInfo?.subscribedTier?.icon" />
                <ion-label class="fs-3 font600 memberInfo">{{
                  userInfo?.subscribedTier?.tierTitle
                }}</ion-label>
              </div>
              <div class="vl"></div>
              <div
                *ngIf="userInfo?.subscribedTier?.offerCount"
                class="ion-no-padding ion-padding-start padr5 d-flex ion-align-items-center"
              >
                <img src="assets/icons/offer.png" />
                <ion-label class="fs-3 font600 memberInfo"
                  >{{ userInfo?.subscribedTier?.offerCount }} Offers</ion-label
                >
              </div>
            </ion-chip>
          </div>
        </div>
      </div>
    </ion-card>

    <div class="d-flex ion-justify-content-center segment-container marb5" *ngIf="tabsInfo.length > 1">
      <ion-segment
        [value]="idx"
        (ionChange)="onSegmentChange($event)"
        lines="none"
        class="border-r10 ion-no-padding"
        value="custom"
        mode="ios"
      >
        <ion-segment-button
          *ngFor="let tab of tabsInfo; let i = index"
          [value]="i"
        >
          <ion-label
            [ngClass]="
              i === idx ? 'white-text-color fs-4 font600' : 'fs-4 font600'
            "
          >
            {{ tab?.title }}
          </ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
  </ion-col>
</ion-row>
